module.exports = __webpack_public_path__ + "static/media/SDFSA_2-960w.17e77209.webp";